import { render, staticRenderFns } from "./BankIdentifierActivity.vue?vue&type=template&id=72fd46dd&scoped=true&"
import script from "./BankIdentifierActivity.vue?vue&type=script&lang=js&"
export * from "./BankIdentifierActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=72fd46dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd46dd",
  null
  
)

export default component.exports